import { useCallback, useMemo, useSyncExternalStore } from 'react';

const changed = 'roll1-ai-results-hidden';
function subscribe(listener: () => void) {
  window.addEventListener('storage', listener);
  window.addEventListener(changed, listener);
  return () => { window.removeEventListener('storage', listener); window.removeEventListener(changed, listener); };
}
function parse(raw: string): string[] {
  try { const value: unknown = JSON.parse(raw); return Array.isArray(value) ? value.filter((id): id is string => typeof id === 'string') : []; }
  catch { return []; }
}

/** Only presentation preferences, scoped to the signed-in user and campaign. No campaign content is stored. */
export function useHiddenAiResults(userId: string | undefined, campaignId: string | undefined) {
  const key = userId && campaignId ? `roll1.ai-hidden-results:${userId}:${campaignId}` : null;
  const read = useCallback(() => { try { return key ? localStorage.getItem(key) ?? '[]' : '[]'; } catch { return '[]'; } }, [key]);
  const raw = useSyncExternalStore(subscribe, read, () => '[]');
  const hiddenResultIds = useMemo(() => parse(raw), [raw]);
  const setResultHidden = useCallback((id: string, hidden: boolean) => {
    if (!key) return;
    const ids = new Set(parse(read()));
    if (hidden) ids.add(id); else ids.delete(id);
    try { localStorage.setItem(key, JSON.stringify([...ids].slice(-500))); window.dispatchEvent(new Event(changed)); }
    catch { /* Leave the card visible when preferences could not be saved. */ }
  }, [key, read]);
  return { hiddenResultIds, setResultHidden };
}
